<rt-work-model-section
  [workModelControl]="workModelControl"
  [readOnly]="!isFormEditable"
  [viewContext]="WorkModelSectionViewContext.Requisition"
  [mode]="hasNewJobEditor ? WorkModelSectionMode.Horizontal : WorkModelSectionMode.Vertical"
></rt-work-model-section>
